import { render } from "./TemperatureRecord.vue?vue&type=template&id=73d0fcf4&scoped=true"
import script from "./TemperatureRecord.vue?vue&type=script&lang=js"
export * from "./TemperatureRecord.vue?vue&type=script&lang=js"

import "./TemperatureRecord.vue?vue&type=style&index=0&id=73d0fcf4&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d0fcf4"]])

export default __exports__